export const getUniqueCommonValues = (arr1, arr2) => {
    const set1 = new Set(arr1)
    const set2 = new Set(arr2)
    return arr2.filter(val => set1.has(val) && set2.has(val))
}

export const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,:\s@\"]+(\.[^<>()[\]\\.,:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )
}